import { Box } from "@mui/material";
import Header from "../../../components/Header";
import { useEffect } from "react";
import {
  addType,
  getTypesError,
  getTypesStatus,
  getTypesSuccess,
  getTypesLoading,
} from "../../../features/typeSlice";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useRestaurant } from "../../../hooks/RestaurantContext";
import OptionForm from "./optionForm";
import { OptionMode } from "../../../models/option.model";
import BackButton from "../../../components/backButton";
import { useTranslation } from "react-i18next";

const AddOption = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { restaurantId } = useRestaurant();
  const status = useSelector(getTypesStatus);
  const error = useSelector(getTypesError);
  const loading = useSelector(getTypesLoading);
  const success = useSelector(getTypesSuccess);

  const initialValues = {
    name: "",
    label: "",
    message: "",
    max: 1,
    min: 0,
    payment: false,
    selection: false,
    mode: OptionMode.ingredients,
    ingredients: [],
    products: [],
  };

  const handleFormSubmit = (values) => {
    dispatch(
      addType({
        body: {
          name: values.name,
          label: values.label,
          message: values.message,
          max: values.max,
          min: values.min,
          payment: values.payment,
          selection: values.selection,
          mode: values.mode,
          ingredients: values.mode === OptionMode.ingredients ? values.ingredients : [],
          products: values.mode === OptionMode.products ? values.products : [],
        }, restaurantId
      })
    );
  };

  useEffect(() => {
    if (status === "addSuccess") {
      toast.success(success);
      navigate("/options");
    } else if (status === "addError") {
      toast.error(error);
    }
  }, [status, error, navigate, success]);

  return (
    <Box m="20px" className="main-application">
      <BackButton/>
      <Header title={t("headers.addOption")} subtitle={t("headers.addOptionSub")} />
      <OptionForm
        buttonText={t("common.submit")}
        handleFormSubmit={handleFormSubmit}
        initialValues={initialValues}
        loading={loading}
      />
    </Box>
  );
};

export default AddOption;
